<script>
/**
 * @file 私教预约
 */

import {teacherPrivateClasses, teacherPrivateHistoryOrder} from '../../__mock__/classes';


export default {
    filters: {
        classesType(value) {
            const obj = {
                postpartum: '产后',
                pregnancy: '孕期'
            };
            return obj[value];
        }
    },
    methods: {
        goto() {
            this.$router.push({name: 'teacher-common-classes'});
        },
        goback() {
            this.$router.push({name: 'teacher-home'});
        },
        toOrderPrivate() {
            this.$router.push({
                name: 'teacher-order-detail'
            });
        },
        handleTouchPlay() {
            let self = this;
            let moveX;
            let startX;
            let movebox = this.$refs.privateContainer;

            // 触摸开始
            function boxTouchStart(e) {
                let touch = e.touches[0];
                startX = touch.pageX;
            }

            function boxTouchMove(e) {
                let touch = e.touches[0];
                moveX = touch.pageX - startX;
            }

            function boxTouchEnd(e) {
                if (moveX > 0) { // 向右

                }

                if (moveX < 0) { // 向左
                    self.$router.push({
                        name: 'teacher-common-classes'
                    });
                }
            }

            // 滑动对象事件绑定
            movebox.addEventListener('touchstart', boxTouchStart, false);
            movebox.addEventListener('touchmove', boxTouchMove, false);
            movebox.addEventListener('touchend', boxTouchEnd, false);
        }

    },
    mounted() {
        this.$nextTick(function () {
            this.handleTouchPlay();
        });
    },
    data() {
        return {
            teacherPrivateClasses: teacherPrivateClasses,
            teacherPrivateHistoryOrder: teacherPrivateHistoryOrder
        };
    }
};
</script>

<template lang="pug">
.forkiss-private-order-container(ref="privateContainer")
    .tabs-wrapper
        .back-btn(@click="goback", data-touch="true")
        .tabs-box
            span.back-icon
            .tab-item(@click="goto")
                span 普通课程
            .tab-item.active
                span 私教课程
    .private-order-wrapper
        .order-private-box(@click="toOrderPrivate", data-touch="true")
            span 预约私教课
            span.circle-arrow-icon
        .order-classes-box(v-for="orderClass in teacherPrivateClasses")
            .classes-img
                .img
            .classes-detail-box
                div
                    .name {{orderClass.author_name}}
                    .time
                        .forkiss-icon-time
                        span {{orderClass.start_time}}
                    .address
                        .forkiss-icon-address
                        span {{orderClass.address}}
        .history-box-title 上课历史({{teacherPrivateHistoryOrder.length}})
        .order-classes-box(v-for="orderClass in teacherPrivateHistoryOrder")
            .classes-img
                .img.history-img
            .classes-detail-box
                div
                    .name {{orderClass.author_name}}
                    .time
                        .forkiss-icon-time
                        span {{orderClass.start_time}}
                    .address
                        .forkiss-icon-address
                        span {{orderClass.address}}
</template>

<style lang="less" scoped>
.forkiss-private-order-container {
    position: relative;
    padding-bottom: 1rem;
    font-size: .24rem;
    background: #f7f7f7;
    min-height: 100%;

    .tabs-wrapper {
        position: relative;

        .back-btn {
            position: absolute;
            z-index: 22;
            top: 50%;
            left: .28rem;
            transform: translateY(-50%);
            width: .2rem;
            height: .36rem;
            background-image: url(../../assets/back-black.png);
            background-size: contain;
            background-repeat: no-repeat;
        }
    }

    .tabs-box {
        display: flex;
        height: .88rem;
        line-height: .88rem;
        padding: 0 1rem;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
        font-size: .28rem;
        background: #FFF;

        .tab-item {
            position: relative;
            flex: 1;
            color: #828d93;
            text-align: center;

            span {
                position: relative;
            }

            &.active {
                color: #a4805b;

                span::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    height: .02rem;
                    background: #a5805a;
                }
            }
        }
    }

    .private-order-wrapper {
        padding: .4rem .3rem .3rem;
    }

    .order-private-box {
        display: block;
        width: 6.9rem;
        height: 1.87rem;
        margin-bottom: .4rem;

        line-height: 1.87rem;
        text-align: center;
        color: #e4ac73;
        font-size: .36rem;
        font-weight: 600;

        background-image: url(../../assets/teacher/order-bg.png);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;


        span {
            display: inline-block;
            vertical-align: middle;
        }
        .circle-arrow-icon {
            display: inline-block;
            width: .36rem;
            height: .36rem;
            background-image: url(../../assets/teacher/circle-arrow-yellow.svg);
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: .2rem;
        }
    }

    .order-classes-box {
        position: relative;
        display: flex;
        height: 2.3rem;
        margin-bottom: .3rem;
        box-shadow: 0 .13rem 13rem 0 rgba(4, 26, 55, 0.07);
        background: #FFF;

        * {
            pointer-events: none;
        }

        .classes-img {
            position: relative;
            height: 100%;
            padding: 0 .28rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .img {
                width: 1.52rem;
                height: 1.52rem;
                border-radius: 50%;
                background-image: url(../../assets/teacher/classes-avatar1.png);
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;

                &.history-img {
                    opacity: .4;
                    background-image: url(../../assets/teacher/classes-avatar3.png) !important;

                }
            }
        }

        &:nth-child(2n+1) {
            .classes-img .img {
                background-image: url(../../assets/teacher/classes-avatar2.png);
            }
        }
        .classes-detail-box {
            position: relative;
            padding-left: .2rem;
            flex: 1;
            display: flex;
            align-items: center;


            .status-waiting {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .48rem;
                background: #ffc68b;
                color: #FFF;
                font-size: .2rem;
            }
            .status-success {
                position: absolute;
                top: 0;
                right: .36rem;
                width: 1.26rem;
                height: .48rem;
                text-align: center;
                line-height: .48rem;
                background: #b0de95;
                color: #FFF;
                font-size: .2rem;
            }
            .class-type {
                color: #999;
                font-size: .2rem;
            }
            .name {
                font-size: .28rem;
                color: #a4805b;
            }
            .time {
                color: #999;
            }
            .address {
                color: #999;
            }
        }
    }

    .history-box-title {
        text-align: center;
        color: #999;
        margin-top: .6rem;
        margin-bottom: .3rem;
        font-size: .24rem;

        &::before {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-right: .15rem;
            vertical-align: super;
        }

        &::after {
            content: "";
            display: inline-block;
            width: .66rem;
            height: 1px;
            background: #CCC;
            margin-left: .15rem;
            vertical-align: super;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/private-classes.vue